// extracted by mini-css-extract-plugin
export default {"subMenu":"styles_subMenu__NMt0J","subMenuButton":"styles_subMenuButton__c-pxt","icon":"styles_icon__OcNB2","stacked":"styles_stacked__PDsl0"};